<app-header-title>
  <span title>{{'worksystemsettings.EmployeeSystems'|translate}}</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-data-grid #grid class="dx-card wide-card" [dataSource]="customDataSource" [showBorders]="false"
    [focusedRowEnabled]="true" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
    [columnHidingEnabled]="true" [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false"
    [showBorders]="false" [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false"
    (onEditingStart)="employeeForm($event)" (onInitNewRow)="employeeForm($event)"
    (onEditorPreparing)="onEditorPreparing($event)">
    <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
    <dxo-pager [visible]="true"></dxo-pager>
    <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="false" [allowDeleting]="false" [allowUpdating]="true"
      [texts]="button">
      <dxo-texts [addRow]="addrowfun('worksystemsettings.EmployeeSystems')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>


<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
      [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxi-column dataField="nameAr" [width]="190" caption="{{'tableinfo.NameAr'|translate}}" [hidingPriority]="8">
    </dxi-column>
    <dxi-column dataField="isActive" caption="{{'tableinfo.isActive'|translate}}">
    </dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton'|translate}}"></dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton'|translate}}"></dxi-button>

    </dxi-column>
  </dx-data-grid>
</div>



